import React from "react";
import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Close,
  Help,
  HelpOutline,
  MenuBook,
  PanTool,
  Pinch,
  Search,
  Swipe,
  TouchApp,
  DownloadForOffline,
} from "@mui/icons-material";
import graphDemoGif from "core/assets/images/graph-demo.gif";

const HelpDialog = () => {
  const [open, setOpen] = React.useState(() => {
    return !Boolean(localStorage.getItem("is-visited"));
  });

  const handleClose = () => {
    localStorage.setItem("is-visited", "true");
    setOpen(false);
  };
  return (
    <>
      <Tooltip title="User Guide">
        <IconButton
          color="inherit"
          size="small"
          onClick={() => {
            setOpen(true);
          }}
        >
          <HelpOutline />
        </IconButton>
      </Tooltip>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Stack spacing={1} direction="row" width="100%" alignItems="center">
            <Typography width="100%" variant="h6" fontWeight="bold">
              User Guide - v{process.env.REACT_APP_VERSION}
            </Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography color="primary" variant="subtitle1" fontWeight="bold">
            App Header:
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            flexWrap="wrap"
          >
            <Stack alignItems="center">
              <Search color="primary" />
              <Typography>Search</Typography>
            </Stack>
            <Stack alignItems="center">
              <MenuBook color="primary" />
              <Typography>Definitions</Typography>
            </Stack>
            <Stack alignItems="center">
              <Help color="primary" />
              <Typography> User Guide</Typography>
            </Stack>
            {window.caches && (
              <Stack alignItems="center">
                <DownloadForOffline color="primary" />
                <Typography>Cache Images for Offline</Typography>
              </Stack>
            )}
          </Stack>
          <br />
          <div>
            <Stack spacing={1}>
              <Typography color="primary" variant="subtitle1" fontWeight="bold">
                Interactive Graph Controls:
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Pinch color="primary" />
                <span>
                  <b>Pinch/Scroll</b> to Zoom In/Out
                </span>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <PanTool color="primary" />
                <span>
                  <b>Drag</b> to Move
                </span>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <TouchApp color="primary" />
                <span>
                  <b>Double Click/Tap</b> to Select
                </span>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Swipe color="primary" />
                <span>
                  <b>Double Click/Tap Hold and Drag</b> to Move Select
                </span>
              </Stack>
              <img src={graphDemoGif} alt="graph demo" width="100%" />
            </Stack>
          </div>
          <br />
          <Alert severity="info">
            You can submit feedback or report bugs at the bottom of the page.
          </Alert>
          <br />
          <Alert severity="info">
            In Isotope Usage Detail section, you can swipe left or right to
            switch usage.
          </Alert>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HelpDialog;
